import React from 'react'
import styles from './styles.css'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import cloneDeep from 'lodash/cloneDeep'
import DeleteIcon from 'react-icons/lib/md/close'
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc'

const SortableItem = SortableElement(({ item }) => <div>{item}</div>)

const SortableList = SortableContainer(({ items, draggable }) => {
  console.log('Item de sortable: ', items)
  return (
    <div>
      {items.map((item, index) => (
        <SortableItem
          disabled={false}
          key={`item-${index}`}
          index={index}
          item={item}
        />
      ))}
    </div>
  )
})

export default class Viewers extends React.Component {
  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func,
    addMe: PropTypes.bool,
    me: PropTypes.func,
    autoAdd: PropTypes.bool,
    url: PropTypes.bool,
    admin: PropTypes.string,
    owner: PropTypes.bool,
    commonSigners: PropTypes.object,
    organization: PropTypes.object,
    prepare: PropTypes.bool
  }

  static defaultProps = {
    autoAdd: true
  }

  state = {
    contactQuery: '',
    showContactList: false
  }

  @autobind
  add() {
    const items = cloneDeep(this.props.value || [])
    items.push({})
    this.props.onChange(items)
  }

  onChange(value, field, index) {
    const items = cloneDeep(this.props.value || [])
    items[index][field] = value
    this.props.onChange(items)
  }

  delete(index) {
    const items = cloneDeep(this.props.value || [])
    items.splice(index, 1)
    this.props.onChange(items)
  }

  buttonsAppear() {
    if (
      (!this.props.url && this.props.owner) ||
      (this.props.organization && this.props.organization.myRole === 'owner')
    ) {
      return true
    }
    return false
  }

  /* Contact list */
  async addContact(email) {
    const items = cloneDeep(this.props.value || [])
    let name = ''
    if (this.props.getUserProfile) {
      const contactData = await this.props.getUserProfile(email)
      name = contactData.getUserProfile ? contactData.getUserProfile.name : ''
    }
    items.push({name, email})
    this.props.onChange(items)
  }
  onListInputChange = () => {
    this.setState({contactQuery: document.getElementById('contact-field-viewers').value, showContactList: true})
  }
  onListInputReset = () => {
    this.setState({contactQuery: '', showContactList: false})
  }
  onListInputBlur = () => {
    setTimeout(() => {
      if (this.state.contactQuery === '') {
        this.setState({contactQuery: '', showContactList: false})
      }
    }, 500)
  }
  renderContactList () {
    if (this.props.commonSigners && this.props.commonSigners.espectadores && this.props.commonSigners.espectadores.length > 0) {
      const contacts = this.props.commonSigners.espectadores
      return (
        contacts
          .filter(contact => contact.includes(this.state.contactQuery))
          .map(contact => (
            <div key={contact} className="addcontactbutton" onClick={() => { this.addContact(contact) }} data-searchstring={contact}>{contact}<span>Agregar</span></div>
          ))
      )
    }
  }
  renderContacts() {
    return (
      <div className={styles.contactlist}>
        <div className="top">
          <input className="os-input-text" id="contact-field-viewers" type="text" value={this.state.contactQuery} onChange={this.onListInputChange} placeholder="Buscar o añadir email de contacto" onFocus={this.onListInputChange} onBlur={this.onListInputBlur}/>
        </div>
        {this.state.showContactList &&
        (<div className="contactListContainer">
          {this.renderContactList()}
          {this.state.contactQuery.length > 0 ? (
            <div className="orion_button" onClick={() => { this.addContact(this.state.contactQuery); this.onListInputReset() }} >Agregar a {this.state.contactQuery}</div>
          ) : (<span></span>)}
        </div>)}
      </div>
    )
  }

  renderViewers() {
    const value = this.props.value || []
    const viewers = value.map((viewer, index) => {
      console.log('value.map')
      const onChange = field => value => this.onChange(value, field, index)
      return (
        <div key={index} className="row">
          <div className="col-xs-12 col-sm-5">
            <Text value={viewer.name} onChange={onChange('name')} placeholder="Nombre" />
          </div>
          <div className="col-xs-10 col-sm-5">
            <Text
              value={viewer.email}
              onChange={onChange('email')}
              placeholder="Email"
              fieldType="email"
            />
          </div>
          {this.props.prepare || this.buttonsAppear() ? (
            <div className="col-xs-2 col-sm-2 end-sm">
              <div className={styles.delete} onClick={() => this.delete(index)}>
                <DeleteIcon size={20} />
              </div>
            </div>
          ) : null}
        </div>
      )
    })
    const onSortEnd = ({ oldIndex, newIndex }) => this.props.onChange(arrayMove(value, oldIndex, newIndex))
    console.log('Retornando SortableList')
    return (
      <SortableList
        distance={2}
        items={viewers}
        size={viewers.length}
        draggable={true}
        onSortEnd={onSortEnd}
      />
    )
  }

  render() {
    return (
      <div className={styles.container}>
        {this.renderViewers()}
        {this.renderContacts()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/Viewers/index.js